import { FC } from 'react';
import { useRoutes } from 'react-router-dom';

import { routerRoutes } from './routes';

export const AppRouter: FC = () => {
  return useRoutes(routerRoutes);
};
